import { createAsyncThunk } from '@reduxjs/toolkit'
import { instance } from '../api/api'

export type CommentTemplateType = {
  id: number
  name: string
  comment: string
  serviceId: number
  createdAt?: string
  updatedAt?: string
}

export type CreateTemplatePayload = {
  name: string
  comment: string
  serviceId: number
}

export type UpdateTemplatePayload = {
  name?: string
  comment?: string
  serviceId?: number
}

export const createTemplate = createAsyncThunk(
  'templates/createTemplate',
  async ({ data, token }: { data: CreateTemplatePayload; token: string }, thunkAPI) => {
    try {
      const response = await instance.post<CommentTemplateType>('templates', data, {
        headers: {
          'Content-Type': 'application/json',
          authorization: `Bearer ${token}`,
        },
      })

      return response.data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || 'Ошибка при создании шаблона',
      )
    }
  },
)

export const getTemplates = createAsyncThunk(
  'templates/getTemplates',
  async ({ token, serviceId }: { token: string; serviceId?: number }, thunkAPI) => {
    try {
      const response = await instance.get<CommentTemplateType[]>('templates', {
        headers: { authorization: `Bearer ${token}` },
        params: serviceId ? { serviceId } : {},
      })

      return response.data
    } catch (error: any) {
      if (error?.response?.status === 401) {
        return thunkAPI.rejectWithValue('Unauthorized')
      }
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || 'Ошибка при получении шаблонов',
      )
    }
  },
)

export const getTemplateById = createAsyncThunk(
  'templates/getTemplateById',
  async ({ templateId, token }: { templateId: number; token: string }, thunkAPI) => {
    try {
      const response = await instance.get<CommentTemplateType>(`templates/${templateId}`, {
        headers: { authorization: `Bearer ${token}` },
      })

      return response.data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || 'Ошибка при получении шаблона',
      )
    }
  },
)

export const updateTemplate = createAsyncThunk(
  'templates/updateTemplate',
  async (
    { templateId, data, token }: { templateId: number; data: UpdateTemplatePayload; token: string },
    thunkAPI,
  ) => {
    try {
      const response = await instance.patch<CommentTemplateType>(`templates/${templateId}`, data, {
        headers: {
          'Content-Type': 'application/json',
          authorization: `Bearer ${token}`,
        },
      })

      return response.data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || 'Ошибка при обновлении шаблона',
      )
    }
  },
)

export const deleteTemplate = createAsyncThunk(
  'templates/deleteTemplate',
  async ({ templateId, token }: { templateId: number; token: string }, thunkAPI) => {
    try {
      await instance.delete(`templates/${templateId}`, {
        headers: { authorization: `Bearer ${token}` },
      })

      return templateId
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || 'Ошибка при удалении шаблона',
      )
    }
  },
)
